import React, { useEffect } from "react";
import styled, { css } from "styled-components";
import IconButton from "@common/LifeAtButton/Variants/IconButton";
import { useAppearanceContext } from "@contexts/AppearanceContext";
import AnnouncementsIcon from "@icons/AnnouncementsIcon.svg";
import { logError } from "@service/ConsoleLoggerService";
import { useCanny } from "../../../canny/CannyProvider";

const CenterDot = css`
    height: 10px;
    width: 10px;
    border-radius: 50%;
    position: absolute;
    top: 10%;
    right: 10%;
    pointer-events: none;
`;

const Container = styled.span`
    position: relative;

    .Canny_BadgeContainer .Canny_Badge {
        ${CenterDot};
        display: block;
    }
`;

const Dot = styled.div`
    ${CenterDot};
    display: none;
    background: ${({ theme }) => theme.textColorSpecial};
`;

const CannyAnnouncementsIcon = styled(AnnouncementsIcon)`
    fill: ${({ theme }) => theme.iconColor};
`;

export default function CannyChangelog() {
    const canny = useCanny();
    const { lightMode } = useAppearanceContext();

    useEffect(() => {
        try {
            canny.initChangelog({
                position: "left",
                align: "top",
                theme: lightMode ? "light" : "dark",
            });
        } catch (e) {
            logError(e);
        }
    }, []);

    return (
        <Container data-canny-changelog>
            <IconButton className={`canny-changelog`} variant={"normal"} size={"small"} onClick={() => {}}>
                <CannyAnnouncementsIcon />
            </IconButton>
            <Dot />
        </Container>
    );
}
